/**
 * import and init global plugins
 */

import Vue from 'vue'

import spinner from '../plugins/spinner'

Vue.use(spinner);
